"use client";
import { useNavigate } from 'react-router-dom';
import styles from "./unauthorized.module.scss";
import { Link } from "react-router-dom";

export default function UnauthorizedPage() {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.iconWrap}>
          <svg
            className={styles.lockIcon}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17 11H7V8a5 5 0 0 1 10 0v3Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <rect
              x="4"
              y="11"
              width="16"
              height="11"
              rx="2"
              stroke="currentColor"
              strokeWidth="2"
            />
            <circle cx="12" cy="16.5" r="1.5" fill="currentColor" />
          </svg>
        </div>

        <h1 className={styles.title}>Access Denied</h1>
        <p className={styles.subtitle}>You are not authenticated</p>
        <p className={styles.description}>
          You don&apos;t have permission to view this page. Please contact
          your administrator to request access or log in with an authorised
          account.
        </p>

        <div className={styles.actions}>
          <Link to="/" className={styles.primaryBtn}>
            Go to Login
          </Link>
          <button
            className={styles.secondaryBtn}
            onClick={() => navigate(-1)}
          >
            Go Back
          </button>
        </div>
        <div className={styles.contactBox}>
          <span className={styles.contactIcon}>ðŸ“ž</span>
          <span>Contact your system administrator for access</span>
        </div>
      </div>
    </div>
  );
}
